export const PRODUCTION = "production";

export const isProd = () =>
  process.env.NODE_ENV === PRODUCTION &&
  window.location.href.indexOf("account.sainsburys.co.uk") !== -1;

export const isIovationEnabled = () =>
  "true" === process.env.REACT_APP_IOVATION_ENABLED;

export const isRecapchaEnabled = () =>
  "true" === process.env.REACT_APP_RECAPTCHA_ENABLED;

export const isLoginRecaptchaEnabled = () =>
  "true" === process.env.REACT_APP_LOGIN_RECAPTCHA_ENABLED;

export const isWebauthnEnabledForNectar = () =>
  "true" === process.env.REACT_APP_WEBAUTHN_ENABLED_NECTAR;

export const isWebauthnEnabledForGol = () =>
  "true" === process.env.REACT_APP_WEBAUTHN_ENABLED_GOL;

export const isWebauthnEnabledForMyaccount = () =>
  "true" === process.env.REACT_APP_WEBAUTHN_ENABLED_MYACCOUNT;
